import integrationAmoCrm from '@/store/modules/adminPanel/settings/integrationAmoCrm'

export default {
  namespaced: true,
  modules: {
    integrationAmoCrm
  }
}
